<template>
  <div id="app">
     <router-view></router-view>
     <loading v-show="isloading"></loading>
  </div>
</template>

<script>

import loading from './components/loading'
import { mapState } from 'vuex'

  export default {
    name: 'app',
      components:{
      loading
    },
    computed: mapState({
      isloading: state => state.loading
    })
  }
</script>

<style>
@import "./css/common.css";
@import "/fonts/iconfont.css";
#app {
  width:100%;
  height:100%;
}

[v-cloak] {
    display: none !important;
}
</style>
